import { render } from "./PostMediaComponent.vue?vue&type=template&id=368b270c&scoped=true&ts=true"
import script from "./PostMediaComponent.vue?vue&type=script&lang=ts"
export * from "./PostMediaComponent.vue?vue&type=script&lang=ts"

import "./PostMediaComponent.vue?vue&type=style&index=0&id=368b270c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368b270c"]])

export default __exports__